export default __webpack_public_path__ + "static/media/hoteldelux.a183e42a.jpg";